import { Photo } from 'ff-canvas';

export const addDashedLines = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number,
    photo: Photo,
    scale: number
) => {
    ctx.save();

    ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)';

    if (photo.clipPaths.length === 0) {
        strokeRectangle(ctx, width, height, scale);
    } else {
        strokePath(ctx, photo, width, height);
    }

    ctx.restore();
};

const strokeRectangle = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number,
    scale: number
) => {
    ctx.lineWidth = Math.max(3, 2.5 * scale);
    ctx.setLineDash([
        Math.round(0.03 * width),
        Math.round(0.03 * height)
    ]);
    ctx.strokeRect(0, 0, width, height);
};

const strokePath = (
    ctx: CanvasRenderingContext2D,
    photo: Photo,
    width: number,
    height: number
) => {
    const largestViewBoxSide = Math.max(photo.clipViewBoxWidth, photo.clipViewBoxHeight);

    const baseLineWidth = 3;
    ctx.lineWidth = (largestViewBoxSide * baseLineWidth) / 100;

    const baseDashSpacing = 0.02;
    const scaledDash = (largestViewBoxSide * baseDashSpacing) / 100;

    for (const clipPath of photo.clipPaths) {

        ctx.save();

        ctx.setLineDash([
            Math.round(scaledDash * width),
            Math.round(scaledDash * height)
        ]);

        ctx.transform(
            width / photo.clipViewBoxWidth,
            0, 0,
            height / photo.clipViewBoxHeight,
            0, 0);

        ctx.stroke(new Path2D(clipPath));

        ctx.restore();
    }
};